import React, { createContext, useContext } from 'react';
import { SEASON_STATUS } from '../services/seasons';

const SeasonContext = createContext();

export const useSeason = () => useContext(SeasonContext);

/**
 * Spiegelt AuctionContext, maar dan voor het administrator-gedeelte.
 *
 * `seasonId` én `seasonName` worden allebei aangeboden omdat de Cloud Functions
 * inconsistent zijn: importChampionsLeagueData en importTeamSquad verwachten de
 * naam ("2025/2026"), importScheduleForSeason en copyFinalRoundsToAuctions de id.
 */
export const SeasonProvider = ({ children, season }) => {
    const value = {
        season,
        seasonId: season?.id,
        seasonName: season?.name,
        // Een afgerond seizoen is alleen-lezen: importeren en de puntentelling wijzigen
        // kan alleen zolang een seizoen loopt, zodat een oude eindstand niet per
        // ongeluk herrekend wordt.
        isLocked: season?.status === SEASON_STATUS.AFGEROND,
    };

    return <SeasonContext.Provider value={value}>{children}</SeasonContext.Provider>;
};
